import React from 'react'

const Share = props => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.62791 19C3.56636 19.0002 3.50512 18.9913 3.44624 18.9737C3.31711 18.9356 3.20395 18.8577 3.12357 18.7516C3.04319 18.6455 2.99985 18.5168 3 18.3846V16.7435C3.00288 14.1873 4.04024 11.7367 5.88447 9.92917C7.7287 8.12167 10.2292 7.10498 12.8373 7.10216H13.0466V3.61486C13.0467 3.49323 13.0836 3.37435 13.1526 3.27325C13.2216 3.17214 13.3197 3.09335 13.4343 3.04681C13.549 3.00028 13.6752 2.98809 13.7969 3.0118C13.9186 3.0355 14.0305 3.09402 14.1183 3.17998L20.816 9.7443C20.8743 9.80138 20.9206 9.86917 20.9522 9.94379C20.9838 10.0184 21 10.0984 21 10.1792C21 10.26 20.9838 10.34 20.9522 10.4146C20.9206 10.4892 20.8743 10.557 20.816 10.6141L14.1183 17.1784C14.0305 17.2644 13.9186 17.3229 13.7969 17.3466C13.6752 17.3703 13.549 17.3581 13.4343 17.3116C13.3197 17.265 13.2216 17.1862 13.1526 17.0851C13.0836 16.984 13.0467 16.8651 13.0466 16.7435V13.1331C11.7958 12.9567 8.04006 13.0051 4.15034 18.7227C4.09328 18.8075 4.01574 18.8771 3.92461 18.9255C3.83347 18.9739 3.73156 18.9995 3.62791 19V19ZM12.8373 8.33297C10.6065 8.33554 8.46409 9.18836 6.86322 10.7111C5.26236 12.2338 4.32852 14.3071 4.25918 16.4924C9.08909 10.5845 13.6645 11.9893 13.873 12.0615C13.9973 12.1021 14.1055 12.1797 14.1825 12.2836C14.2595 12.3875 14.3015 12.5124 14.3025 12.6408V15.2575L19.484 10.1792L14.3025 5.10086V7.71757C14.3025 7.88078 14.2363 8.03731 14.1185 8.15272C14.0008 8.26813 13.8411 8.33297 13.6745 8.33297H12.8373Z'
      fill='white'
    />
  </svg>
)

export default Share
